/**
 * Shared preview runtime for the Builder preview experience.
 *
 * One built-in registry + config for both the preview host (BuilderPage) and the
 * chrome-free live route (LivePreviewPage). The generated schema is NOT cached on the
 * client — both pages fetch the persisted builder from the backend by id (the DB is the
 * single source of truth). The backend produces the canonical SiteSchema directly, so this
 * only wires the Builder Engine + registry for rendering (no migration/transform step).
 */
import { createBuilderRegistry } from '../site-builder/components'
import type { RuntimeConfig, SectionRegistry } from '../site-builder/runtime'

/** One registry (kind → RegistryEntry) with all built-in kinds, created once. */
export const builderRegistry: SectionRegistry = createBuilderRegistry()

/** Section render failures are contained by the engine; log in dev only. */
export const builderConfig: RuntimeConfig = {
  onError: (error, context) => {
    if (import.meta.env.DEV) console.error('[builder] section render error', context, error)
  },
}
